import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'ghg_emissions_offset_scope'

export const dataPointDefinition = {
  retracedId: 'ghg_emissions_offset_scope',
  name: 'How much of your emissions are you offsetting?',
  meta: {
    isMultipleRow: false,
    columns: [
      {
        key: 1,
        id: 'ghg_emissions_offset_scope1',
        name: 'SCOPE_1',
        text: 'Scope 1',
        type: 'NUMBER_UOM',
        unit: 'PERCENTAGE',
        unitText: '%',
      },
      {
        key: 2,
        id: 'ghg_emissions_offset_scope2',
        name: 'SCOPE_2',
        text: 'Scope 2',
        type: 'NUMBER_UOM',
        unit: 'PERCENTAGE',
        unitText: '%',
      },
      {
        key: 3,
        id: 'ghg_emissions_offset_scope3',
        name: 'SCOPE_3',
        text: 'Scope 3',
        type: 'NUMBER_UOM',
        unit: 'PERCENTAGE',
        unitText: '%',
      },
    ],
  },
  fieldTypeId: 'TABLE',
  type: 'RELATIONAL',
  options: [
    {
      unit: [
        {
          key: 'PERCENTAGE',
          text: 'Percentage',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'object',
        properties: {
          unit: {
            type: 'string',
            enum: ['PERCENTAGE'],
          },
          ghgEmissionsOffsetScope1: {
            type: 'number',
            maximum: 100,
          },
          ghgEmissionsOffsetScope2: {
            type: 'number',
            maximum: 100,
          },
          ghgEmissionsOffsetScope3: {
            type: 'number',
            maximum: 100,
          },
        },
        required: ['ghgEmissionsOffsetScope1', 'unit', 'ghgEmissionsOffsetScope3', 'ghgEmissionsOffsetScope2'],
      },
    },
    required: ['value'],
  },
  externalIds: [],
  sortingId: 620,
  sectionId: '2.1.5.1',
  impactArea: 'GHG Emissions',
  impactAreaId: 'GHG_EMISSIONS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
